"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteNumerationFromParagraphsCommand = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var command_states_1 = require("../command-states");
var numbering_list_command_base_1 = require("./numbering-list-command-base");
var DeleteNumerationFromParagraphsCommand = (function (_super) {
    tslib_1.__extends(DeleteNumerationFromParagraphsCommand, _super);
    function DeleteNumerationFromParagraphsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteNumerationFromParagraphsCommand.prototype.getState = function (options) {
        if (options === void 0) { options = this.convertToCommandOptions(undefined); }
        return new command_states_1.IntervalCommandStateEx(this.isEnabled(), list_1.ListUtils.deepCopy(options.intervalsInfo.intervals));
    };
    DeleteNumerationFromParagraphsCommand.prototype.executeCore = function (_state, options) {
        var paragraphIndices = options.subDocument.getParagraphIndicesByIntervals(options.intervalsInfo.intervals);
        this.history.beginTransaction();
        this.deleteNumberingList(paragraphIndices, options.subDocument);
        this.history.endTransaction();
        return true;
    };
    DeleteNumerationFromParagraphsCommand.prototype.getNumberingListType = function () {
        return null;
    };
    return DeleteNumerationFromParagraphsCommand;
}(numbering_list_command_base_1.NumberingListCommandBase));
exports.DeleteNumerationFromParagraphsCommand = DeleteNumerationFromParagraphsCommand;
